import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { InviteOwnerTemplate } from 'components/Templates'

const InviteOwner: FC = () => {
  return (
    <Layout headline={'新規店舗作成'} title={'店舗オーナーを招待'}>
      <InviteOwnerTemplate />
    </Layout>
  )
}

export default InviteOwner
